/* Uit Krabbelpaal.dc.html; bodies letterlijk overgenomen. */

import { api, asJson, serverMsg } from '../lib/api.js';
import { PB_URL } from '../lib/config.js';
import { avatarUrl, squareThumb } from '../lib/pixels.js';
import { playBlip, playFanfare, playPop } from '../lib/sound.js';
import { parsePollVotes } from '../lib/text.js';
import * as store from '../lib/store.js';

export default {
  pollVoterId() { return this.state.accountId || ('naam:' + (this.state.author || 'gast')); },

  myPollVote(poll) {
      const p = poll || this.state.poll;
      if (!p) return null;
      const hit = p.votes.find((v) => v.id === this.pollVoterId());
      if (hit) return hit.c;
      try { return store.get('gp_poll_' + p.id) || null; } catch (e) { return null; }
    },

  async fetchPoll() {
      try {
        const res = await api(`${PB_URL}/api/collections/paal_polls/records?filter=${encodeURIComponent('active=true')}&sort=-created&perPage=1`);
        if (!res.ok) return;
        const data = await res.json();
        const r = (data.items || [])[0];
        if (!r) { if (this.state.poll) this.setState({ poll: null, pollOpen: false }); this.pollLoaded = true; return; }
        const poll = {
          id: r.id,
          question: r.question || '',
          optionA: r.optionA || 'A',
          optionB: r.optionB || 'B',
          imageA: r.imageA ? `${PB_URL}/api/files/paal_polls/${r.id}/${r.imageA}` : '',
          imageB: r.imageB ? `${PB_URL}/api/files/paal_polls/${r.id}/${r.imageB}` : '',
          votes: parsePollVotes(r.votedBy)
        };
        const isNew = !this.state.poll || this.state.poll.id !== poll.id;
        this.setState({ poll });
        if (isNew && this.pollLoaded && !this.myPollVote(poll)) { playBlip(); this.notify('Er is een nieuwe poll! Geef je stem.'); }
        this.pollLoaded = true;
      } catch (e) {}
    },

  async votePoll(choice) {
      const p = this.state.poll;
      if (!p || this.state.pollVoting) return;
      if (!this.ensureName('Log in of maak een account aan om te kunnen stemmen op de poll.')) return;
      const me = this.pollVoterId();
      const votes = p.votes.filter((v) => v.id !== me).concat([{ id: me, c: choice }]);
      this.setState({ pollVoting: true, pollError: '', poll: Object.assign({}, p, { votes }) });
      try { store.set('gp_poll_' + p.id, choice); } catch (e) {}
      playPop();
      try {
        let latest = votes;
        const cur = await api(`${PB_URL}/api/collections/paal_polls/records/${p.id}`);
        if (cur.ok) {
          const j = await cur.json();
          latest = parsePollVotes(j.votedBy).filter((v) => v.id !== me).concat([{ id: me, c: choice }]);
        }
        const res = await api(`${PB_URL}/api/collections/paal_polls/records/${p.id}`, asJson('PATCH', { votedBy: JSON.stringify(latest) }));
        if (!res.ok) throw new Error('patch');
        this.setState({ pollVoting: false });
        this.fetchPoll();
      } catch (e) {
        this.setState({ pollVoting: false, pollError: 'Je stem staat voorlopig alleen op dit apparaat.' });
      }
    },

  onPollQ(e) { return this.setState({ pollQ: e.target.value }); },

  onPollA(e) { return this.setState({ pollA: e.target.value }); },

  onPollB(e) { return this.setState({ pollB: e.target.value }); },

  async pickPollImage(which, e) {
      const f = e.target.files && e.target.files[0];
      if (f) await this.pickPollImageFile(which, f);
    },

  onPollDragOver(which, e) {
      e.preventDefault();
      if (!this.state[`pollDrag${which}`]) this.setState({ [`pollDrag${which}`]: true });
    },

  onPollDragLeave(which, e) {
      e.preventDefault();
      if (this.state[`pollDrag${which}`]) this.setState({ [`pollDrag${which}`]: false });
    },

  async onPollDrop(which, e) {
      e.preventDefault();
      this.setState({ [`pollDrag${which}`]: false });
      const f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) await this.pickPollImageFile(which, f);
    },

  async pickPollImageFile(which, f) {
      try {
        const { blob, url } = await squareThumb(f, 128);
        if (which === 'A') { this.pollBlobA = blob; this.setState({ pollPrevA: url, pollFormError: '' }); }
        else { this.pollBlobB = blob; this.setState({ pollPrevB: url, pollFormError: '' }); }
      } catch (err) {
        this.setState({ pollFormError: 'Dat plaatje kon niet gelezen worden.' });
      }
    },

  async createPoll() {
      if (!this.isMaintainer) return;
      const q = (this.state.pollQ || '').trim();
      if (!q) { this.setState({ pollFormError: 'Schrijf eerst de stelling.' }); return; }
      const a = (this.state.pollA || '').trim() || 'A';
      const b = (this.state.pollB || '').trim() || 'B';
      this.setState({ pollCreating: true, pollFormError: '' });
      try {
        // Eerst de nieuwe, dan pas de oude uit. Andersom stond er na een mislukte
        // upload helemaal geen poll meer.
        const fd = new FormData();
        fd.append('question', q);
        fd.append('optionA', a);
        fd.append('optionB', b);
        fd.append('active', 'true');
        fd.append('votedBy', '[]');
        if (this.pollBlobA) fd.append('imageA', this.pollBlobA, 'poll-a.png');
        if (this.pollBlobB) fd.append('imageB', this.pollBlobB, 'poll-b.png');
        const res = await api(`${PB_URL}/api/collections/paal_polls/records`, { method: 'POST', body: fd });
        if (!res.ok) {
          throw new Error(await serverMsg(res));
        }
        let nieuwId = '';
        try { nieuwId = (await res.clone().json()).id || ''; } catch (e) {}
        // Zonder id van de nieuwe weten we niet welke we moeten laten staan; fetchPoll
        // pakt toch de nieuwste, dus dan blijven de oude maar even aan.
        const old = nieuwId ? await api(`${PB_URL}/api/collections/paal_polls/records?filter=${encodeURIComponent('active=true')}&perPage=50&fields=id`) : null;
        if (old && old.ok) {
          const j = await old.json();
          await Promise.all((j.items || []).filter((r) => r.id !== nieuwId)
            .map((r) => api(`${PB_URL}/api/collections/paal_polls/records/${r.id}`, asJson('PATCH', { active: false })).catch(() => {})));
        }
        this.pollBlobA = null; this.pollBlobB = null;
        playFanfare();
        // De moderator krijgt de poll zelf ook: melding + open venster, en mag gewoon stemmen.
        this.pollLoaded = true;
        this.notify('Je poll staat live! Jij mag ook stemmen.');
        this.setState({ pollCreating: false, pollQ: '', pollA: '', pollB: '', pollPrevA: '', pollPrevB: '', dialog: null, pollOpen: true }, this.fetchPoll);
      } catch (e) {
        this.setState({
          pollCreating: false,
          pollFormError: 'Poll maken mislukt: ' + e.message + ' Bestaat de collectie paal_polls met question, optionA, optionB (tekst), imageA en imageB (file), active (boolean) en votedBy (tekst)?'
        });
      }
    },

  async endPoll() {
      const p = this.state.poll;
      if (!p || !this.isMaintainer) return;
      this.setState({ poll: null, pollOpen: false });
      try {
        await api(`${PB_URL}/api/collections/paal_polls/records/${p.id}`, asJson('PATCH', { active: false }));
      } catch (e) {}
    },

  pollDropStyle(which) {
      const dragging = !!this.state[`pollDrag${which}`];
      const filled = !!this.state[`pollPrev${which}`];
      return {
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '9px',
        width: '100%', boxSizing: 'border-box', padding: '14px', minHeight: '150px', cursor: 'pointer',
        borderRadius: '12px', border: '3px ' + (filled ? 'solid' : 'dashed') + ' ' + (dragging ? 'var(--paars)' : (filled ? 'var(--ink)' : 'var(--rand-stippel)')),
        background: dragging ? 'var(--lila)' : '#fff', color: 'var(--tekst-3)',
        transition: 'background .18s ease, border-color .18s ease'
      };
    },

  pollVals() {
      const p = this.state.poll;
      const my = p ? this.myPollVote(p) : null;
      const counts = { A: 0, B: 0 };
      if (p) p.votes.forEach((v) => { if (counts[v.c] !== undefined) counts[v.c]++; });
      const tot = counts.A + counts.B;
      const letterStyle = (col) => ({
        display: 'flex', alignItems: 'center', justifyContent: 'center', width: '32px', height: '32px', flex: '0 0 auto',
        borderRadius: '12px', border: '3px solid var(--ink)', background: col, fontSize: '15px', fontWeight: 700
      });
      /**
       * Wie er op een keuze gestemd heeft.
       *
       * Een stem is `{ id, c }`, en die id is een account-id of "naam:iemand" voor
       * wie nog geen account had. Van de eerste soort weten we het kopje en de naam,
       * van de tweede alleen de naam. Wie helemaal niets achterliet valt onder het
       * getal achteraan, net zoals bij de hartjes op een krabbel.
       *
       * Dit was het meest gevraagde uit de ideeënbus: je zag hoeveel stemmen er
       * waren, maar niet van wie.
       */
      const stemmersVan = (letter) => {
        const rijen = [];
        let anoniem = 0;
        (p ? p.votes : []).forEach((v) => {
          if (v.c !== letter) return;
          const acc = (this.state.accounts || []).find((a) => a.id === v.id);
          if (acc) { rijen.push({ id: acc.id, name: acc.name, avatar: acc.avatar }); return; }
          const naam = String(v.id || '').startsWith('naam:') ? String(v.id).slice(5) : '';
          if (naam) rijen.push({ id: '', name: naam, avatar: '' });
          else anoniem++;
        });
        return { rijen, anoniem };
      };

      const base = p ? [
        { letter: 'A', label: p.optionA, img: p.imageA, n: counts.A, col: 'var(--geel)' },
        { letter: 'B', label: p.optionB, img: p.imageB, n: counts.B, col: 'var(--poll-b)' }
      ] : [];
      return {
        hasPoll: !!p,
        showPollDot: !!p && !my,
        openPoll: () => this.setState({ pollOpen: true }),
        closePoll: () => this.setState({ pollOpen: false }),
        showPoll: !!p && this.state.pollOpen,
        pollQuestion: p ? p.question : '',
        pollNotVoted: !!p && !my,
        pollVoted: !!p && !!my,
        hasPollError: !!this.state.pollError,
        pollError: this.state.pollError || '',
        pollTotalLabel: tot === 1 ? '1 stem tot nu toe' : tot + ' stemmen tot nu toe',
        pollChoices: base.map((o) => ({
          letter: o.letter, label: o.label, hasImg: !!o.img, imgUrl: o.img,
          onVote: () => this.votePoll(o.letter),
          letterStyle: letterStyle(o.col),
          cardStyle: {
            flex: '1 1 190px', minWidth: '0', height: 'auto', flexDirection: 'column', gap: '11px',
            alignItems: 'center', justifyContent: 'center', padding: '16px', borderRadius: '16px', background: '#fff'
          }
        })),
        pollResults: base.map((o) => {
          const pct = tot ? (o.n / tot) * 100 : 0;
          const empty = !o.n || !tot;
          const full = pct >= 99.99;
          const { rijen, anoniem } = stemmersVan(o.letter);
          return {
            letter: o.letter, label: o.label, hasImg: !!o.img, imgUrl: o.img,
            letterStyle: letterStyle(o.col),
            isMine: my === o.letter,
            votesLabel: Math.round(pct) + '%  ·  ' + o.n,
            // De koppen van wie hierop stemde, overlappend naast elkaar zoals de
            // rij rechtsboven in de kop. Meer dan tien wordt een muur van koppen,
            // dus daarna zegt een getal hoeveel er nog volgen.
            heeftStemmers: rijen.length > 0 || anoniem > 0,
            stemmers: rijen.slice(0, 10).map((r, i) => ({
              name: r.name,
              avatarUrl: avatarUrl(r.avatar),
              onOpen: r.id ? () => { this.setState({ pollOpen: false }); this.openProfile(r.id); } : undefined,
              style: {
                width: '26px', height: '26px', flex: '0 0 auto', imageRendering: 'pixelated',
                border: '2px solid var(--ink)', borderRadius: '8px', background: '#fff', display: 'block',
                marginLeft: i === 0 ? '0' : '-8px', cursor: r.id ? 'pointer' : 'default',
                position: 'relative', zIndex: String(20 - i)
              }
            })),
            stemmersTitel: rijen.map((r) => r.name).join(', '),
            restLabel: (() => {
              const rest = Math.max(0, rijen.length - 10) + anoniem;
              return rest > 0 ? '+' + rest : '';
            })(),
            heeftRest: Math.max(0, rijen.length - 10) + anoniem > 0,
            barStyle: {
              boxSizing: 'border-box',
              width: empty ? '0%' : 'max(14px, ' + pct + '%)',
              height: '100%', background: o.col,
              borderRight: 'none',
              borderRadius: full ? '999px' : '0 999px 999px 0',
              transition: 'width .55s cubic-bezier(.22,1,.36,1)'
            }
          };
        }),
        // Eén rij koppen onder een balk. Geen vak eromheen: het is een bijschrift.
        pollStemmersRijStyle: { display: 'flex', alignItems: 'center', gap: '7px', marginTop: '2px' },
        pollStemmersKoppenStyle: { display: 'flex', alignItems: 'center', flex: '0 0 auto' },
        pollRestStyle: { fontSize: '12px', fontWeight: 700, color: 'var(--tekst-2)', flex: '0 0 auto' },
        endPoll: this.endPoll,
        showPollNew: this.isMaintainer && this.state.dialog === 'pollnew',
        openPollForm: () => {
          this.pollBlobA = null; this.pollBlobB = null;
          this.setState({ dialog: 'pollnew', pollQ: '', pollA: '', pollB: '', pollPrevA: '', pollPrevB: '', pollFormError: '' });
        },
        // Sluiten gooit het concept weg: de volgende keer begin je met een leeg formulier.
        closePollForm: () => {
          this.pollBlobA = null; this.pollBlobB = null;
          this.setState({ dialog: 'mod', pollQ: '', pollA: '', pollB: '', pollPrevA: '', pollPrevB: '', pollFormError: '' });
        },
        pollFormGridStyle: { display: 'grid', gridTemplateColumns: this.state.isMobile ? '1fr' : '1fr 1fr', gap: '14px' },
        noPollPrevA: !this.state.pollPrevA,
        noPollPrevB: !this.state.pollPrevB,
        pollDropStyleA: this.pollDropStyle('A'),
        pollDropStyleB: this.pollDropStyle('B'),
        onPollDragOverA: (e) => this.onPollDragOver('A', e),
        onPollDragLeaveA: (e) => this.onPollDragLeave('A', e),
        onPollDropA: (e) => this.onPollDrop('A', e),
        onPollDragOverB: (e) => this.onPollDragOver('B', e),
        onPollDragLeaveB: (e) => this.onPollDragLeave('B', e),
        onPollDropB: (e) => this.onPollDrop('B', e),
        pollHintA: this.state.pollPrevA ? 'Klik of sleep om te vervangen' : 'Sleep een plaatje hierin, of klik om te kiezen',
        pollHintB: this.state.pollPrevB ? 'Klik of sleep om te vervangen' : 'Sleep een plaatje hierin, of klik om te kiezen',
        pollQ: this.state.pollQ || '',
        pollA: this.state.pollA || '',
        pollB: this.state.pollB || '',
        onPollQ: this.onPollQ,
        onPollA: this.onPollA,
        onPollB: this.onPollB,
        onPollFileA: (e) => this.pickPollImage('A', e),
        onPollFileB: (e) => this.pickPollImage('B', e),
        hasPollPrevA: !!this.state.pollPrevA,
        pollPrevA: this.state.pollPrevA || '',
        hasPollPrevB: !!this.state.pollPrevB,
        pollPrevB: this.state.pollPrevB || '',
        createPoll: this.createPoll,
        pollCreating: !!this.state.pollCreating,
        pollCreateLabel: this.state.pollCreating ? 'Poll maken…' : 'Start de poll',
        hasPollFormError: !!this.state.pollFormError,
        pollFormError: this.state.pollFormError || '',
        hasActivePoll: !!p
      };
    }
};
